<section class="forgot-password">
  <div class="flex flex-col gap-3 items-center">
    <div class="w-24 h-24">
      <img
        ngSrc="/assets/images/logo.png"
        class="w-full h-full"
        width="150"
        height="150"
      />
    </div>
    <p class="text-primary-main !font-bold text-sm">
      ARAD MEAT AUTOMATION SYSTEM
    </p>
  </div>

  <div
    class="min-w-80 min-h-64 flex flex-col gap-2 items-center shadow rounded-md p-4 bg-background-default"
  >
    <div class="forgot-password__header">
      <h2 class="forgot-password__title">
        @if (authService.userForgotPassState().state === 0) {
          {{ "auth.forgotPassword" | translate }}
        } @else if (authService.userForgotPassState().state === 1) {
          {{ "authentication" | translate }}
        }
      </h2>
      <i class="iconsax forgot-password__icon" icon-name="lock-2"></i>
    </div>
    @if (authService.userForgotPassState().state === 0) {
      <form (submit)="submit()" [formGroup]="forgotForm" preventFormSubmit>
        <div class="forgot-password__field">
          <app-input
            class="block w-full"
            formControlName="mobile"
            [formGroup]="forgotForm"
            type="text"
            labelKey="auth.phoneLabel"
          ></app-input>
          <!-- <app-phone-number
            formControlName="mobile"
            label="auth.phoneNumber"
            placeholder="auth.enterPhoneNumber"
            icon="phone"
          ></app-phone-number> -->
        </div>
        <div class="forgot-password__submit">
          <app-button
            variant="filled"
            color="primary-main"
            type="submit"
            icon="chevron-right"
            size="large"
            [disabled]="!forgotForm.dirty"
            >{{ "auth.resetPassword" | translate }}
          </app-button>
        </div>
      </form>
    } @else if (authService.userForgotPassState().state === 1) {
      <form
        (submit)="submitOtp()"
        [formGroup]="forgotOtpForm"
        preventFormSubmit
      >
        <div class="forgot-password__field">
          <app-input
            formControlName="password"
            [formGroup]="forgotOtpForm"
            [type]="!isPasswordVisible ? 'password' : 'text'"
            labelKey="auth.passwordLabel"
            placeholderKey="auth.passwordPlaceholder"
            icon="lock-2"
            [messages]="{
              required: 'requires.password',
              minlength: 'requires.passwordLength',
            }"
          ></app-input>

          <button
            class="absolute top-4 left-3"
            type="button"
            (click)="togglePasswordVisibility()"
          >
            <mat-icon>{{
              isPasswordVisible ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
        </div>
        <div class="forgot-password__field">
          <app-input
            formControlName="password_confirmation"
            [formGroup]="forgotOtpForm"
            [type]="!isRepeatPasswordVisible ? 'password' : 'text'"
            labelKey="auth.repasswordLabel"
            placeholderKey="auth.repasswordPlaceholder"
            icon="lock-2"
            [messages]="{required: 'requires.rePassword'}"
          ></app-input>

          <button
            class="absolute top-4 left-3"
            type="button"
            (click)="toggleRepeatPasswordVisibility()"
          >
            <mat-icon>{{
              isRepeatPasswordVisible ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
        </div>
        @if (forgotOtpForm.errors?.["passwordNotMatch"]) {
          <span class="forgot-password__password-no-match">{{
            "requires.passwordNoMatch" | translate
          }}</span>
        }
        <div class="forgot-password__field">
          <app-input
            pwjOnlyNumber
            formControlName="otp"
            [formGroup]="forgotOtpForm"
            labelKey="auth.verificationCode"
            placeholderKey="auth.enterVerificationCode"
            icon="lock-2"
            [messages]="{
              required: 'requires.verificationCode',
            }"
          ></app-input>
        </div>
        <div class="forgot-password__resend-otp">
          @if (!showResendButton) {
            <p class="otp-timer">
              <span class="forgot-password__numbers">
                {{ formattedTimer }}
              </span>
              <span class="forgot-password__description">
                {{ "auth.receiveCode" | translate }}
              </span>
            </p>
          } @else {
            <button
              type="button"
              class="resend-otp-button"
              (click)="resendOtp()"
            >
              <span>
                {{ "auth.getCodeAgain" | translate }}
              </span>
              <span>
                <i
                  class="iconsax resend-otp-button__icon"
                  icon-name="chevron-right"
                ></i>
              </span>
            </button>
          }
        </div>
        <div class="forgot-password__submit">
          <app-button
            variant="filled"
            color="primary-main"
            type="submit"
            icon="chevron-right"
            size="large"
            [disabled]="!forgotOtpForm.dirty || isVerifyOtpBtnDisable"
            >{{ "send" | translate }}
          </app-button>
        </div>
      </form>
    }
  </div>
</section>
